/**
 * NUDIENT: Hjälten, paket G1, M-102. Plan: nudient/PLAN-G1-hjalten.md.
 * Markup i sections/nudient-hero.liquid.
 *
 * Knappen i panelen och remsan, "Visa mina skal", är
 * snippets/nudient-cases-cta.liquid med assets/nudient-cases-cta.js, samma som
 * i megamenyn, M-149. Elementet nudient-hero-gate har inget eget skript.
 *
 * nudient-hero-slides, bilderna och prickarna, Slider/Dots 1135:2720:
 * - Bilderna ligger i en rad som rullar i sidled med fäst läge, så att de går
 *   att svepa. Prickarna följer den bild som syns mest, och ett tryck på en
 *   prick rullar fram dess bild. Ingen automatisk växling, planen punkt 13.
 * - Med minskad rörelse hoppar rullningen direkt till bilden.
 *
 * Värden som inte är tokens:
 * - 0.5: en bild räknas som synlig när minst hälften syns.
 */

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class NudientHeroSlides extends HTMLElement {
  #observer = /** @type {IntersectionObserver | null} */ (null);

  connectedCallback() {
    this.track = this.querySelector('.nudient-hero__track');
    this.slides = [...this.querySelectorAll('[data-nudient-hero-slide]')];
    this.dots = [...this.querySelectorAll('[data-nudient-hero-dot]')];
    if (!this.track || this.slides.length < 2 || this.dots.length < 2) return;

    this.dots.forEach((dot) => dot.addEventListener('click', this.#onDot));
    this.#observer = new IntersectionObserver(this.#onIntersect, { root: this.track, threshold: 0.5 });
    this.slides.forEach((slide) => this.#observer?.observe(slide));
  }

  disconnectedCallback() {
    this.dots?.forEach((dot) => dot.removeEventListener('click', this.#onDot));
    this.#observer?.disconnect();
    this.#observer = null;
  }

  /** @param {number} index */
  #mark(index) {
    this.dots.forEach((dot, i) => {
      if (i === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  /** @param {IntersectionObserverEntry[]} entries */
  #onIntersect = (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const index = this.slides.indexOf(/** @type {HTMLElement} */ (entry.target));
      if (index >= 0) this.#mark(index);
    }
  };

  /** @param {Event} event */
  #onDot = (event) => {
    const dot = /** @type {HTMLElement} */ (event.currentTarget);
    const index = Number(dot.dataset.nudientHeroDot);
    const slide = this.slides[index];
    if (!slide || !this.track) return;
    this.track.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    this.#mark(index);
  };
}

if (!customElements.get('nudient-hero-slides')) customElements.define('nudient-hero-slides', NudientHeroSlides);
